import { getAnsweredString, getAnsweredValue, MatcherAnswers } from './types';
import { BUSINESS_OPTIONS } from './checkboxOptions';
import { INDUSTRY_OPTIONS } from './industryOptions';

// The reveal slot gets the highest-weighted criterion (specific need) when all 3 are known, to
// give it the most emphasis.
export interface MatcherSearchCriteria {
  spinLabels: [string, string];
  revealLabel: string;
}

const GENERIC_SPIN_LABELS: [string, string] = [
  'Reviewing your needs',
  'Comparing tax pros'
];

function findIndustryLabel(answers: MatcherAnswers): string | undefined {
  const code = getAnsweredString(answers.industry);
  return INDUSTRY_OPTIONS.find((option) => option.code === code)?.label;
}

// The most specific "need" we can point to today is whichever business-service option the fan
// picked - the only Services follow-up currently wired into the flow. Extend this once
// Problem/Plan/File are back on the spine and can contribute a more specific need of their own.
function findSpecificNeedLabel(answers: MatcherAnswers): string | undefined {
  const selectedIds = getAnsweredValue(answers.business);
  const firstId = Array.isArray(selectedIds) ? selectedIds[0] : undefined;
  return BUSINESS_OPTIONS.find((option) => option.id === firstId)?.label;
}

export function buildMatchCriteria(
  answers: MatcherAnswers,
  location: string
): MatcherSearchCriteria {
  const industryLabel = findIndustryLabel(answers);
  const specificNeedLabel = findSpecificNeedLabel(answers);

  if (!location || !industryLabel || !specificNeedLabel) {
    return {
      spinLabels: GENERIC_SPIN_LABELS,
      revealLabel: `Searching pros serving ${location || 'your area'}`
    };
  }

  return {
    spinLabels: [`Serves ${location}`, `Handles ${industryLabel}`],
    revealLabel: `Specializes in ${specificNeedLabel}`
  };
}
